// extracted by mini-css-extract-plugin
module.exports = {"faq":"index-module--faq--1AIqM","faqTypes":"index-module--faq-types--3OwZt","faqBody":"index-module--faq-body--2sWID"};